import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import leaf from '../../assets/images/leaf.svg';
import loginLogo from '../../assets/images/loginLogo.png';
import { BatterySellerData } from '../../api/service/BatteryInterfaces';
import { StuffPageUrl } from '../../url/poenUrl';
import { useNavigate } from 'react-router-dom';
import BuyerBatteryService from '../../api/service/buyer/BuyerBatteryService';

const Container = styled.div`
  background-color: ${(props) => props.theme.colors.silverColor};
  width: 100%;
  padding: 20px;
  margin-top: 20px;
  border-radius: 30px;

  @media (max-width: 768px) {
    padding: 15px;
    border-radius: 20px;
    margin-top: 0px;
    border-radius: 10px;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 30px;

  h2 {
    font-size: 28px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    color: ${(props) => props.theme.colors.textColor};

    @media (max-width: 768px) {
      font-size: 22px;
    }

    @media (max-width: 480px) {
      font-size: 18px;
    }
  }

  img {
    width: 24px;

    @media (max-width: 768px) {
      width: 20px;
    }

    @media (max-width: 480px) {
      width: 16px;
    }
  }
`;

const Table = styled.table`
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  border-collapse: collapse;
  background-color: ${(props) => props.theme.colors.whiteColor};
  border: 1px solid ${(props) => props.theme.colors.borderColor};
  color: ${(props) => props.theme.colors.textColor};
  overflow: hidden;

  th,
  td {
    padding: 20px;
    text-align: left;
    border: 1px solid ${(props) => props.theme.colors.borderColor};

    @media (max-width: 768px) {
      padding: 10px;
      font-size: 12px;
    }
  }

  th {
    width: 150px;
    text-align: center; /* 가로 가운데 정렬 */
    vertical-align: middle; /* 세로 가운데 정렬 */
    background-color: ${(props) => props.theme.colors.sub3Color};
    font-weight: 400;

    @media (max-width: 768px) {
      width: 100px;
    }
  }

  td {
    background-color: ${(props) => props.theme.colors.whiteColor};
  }
`;

const Footer = styled.div`
  text-align: center;
  margin-top: 30px;

  img {
    max-width: 300px;

    @media (max-width: 768px) {
      max-width: 200px;
      width: 100%;
    }
  }
`;

function StuffTab4() {
  const navigate = useNavigate();
  const [batteryId, setBatteryId] = useState<string | null>(null);
  const [sellerData, setSellerData] = useState<BatterySellerData | null>(null);

  useEffect(() => {
    // 로컬스토리지에서 'StuffbatteryId'를 가져옵니다.
    const storedBatteryId = sessionStorage.getItem('StuffbatteryId');

    if (storedBatteryId) {
      setBatteryId(storedBatteryId); // 로컬스토리지에 값이 있으면 batteryId 상태에 저장
    } else {
      // 배터리 ID가 없으면 경고창을 띄우고 DiagnosisTab1로 돌아갑니다.
      alert('배터리를 선택해 주세요!');
      navigate(`${StuffPageUrl}?activeTab=0`); // DiagnosisPage의 첫 번째 탭으로 이동
    }
  }, [navigate]);

  useEffect(() => {
    if (batteryId) {
      fetchSellerData(batteryId);
    }
  }, [batteryId]); // batteryId가 변경될 때마다 호출

  const fetchSellerData = async (batteryId: string) => {
    try {
      const response = await BuyerBatteryService.getBatterySellers(batteryId);
      setSellerData(response.data);
    } catch (error) {
      console.error('판매자 정보 조회 실패:', error);
    }
  };

  return (
    <Container>
      <Header>
        <img src={leaf} alt="leaf" />
        <h2>판매자 정보</h2>
      </Header>
      <Table>
        <tbody>
          <tr>
            <th>사업명</th>
            <td>{sellerData?.company || '-'}</td>
          </tr>
          <tr>
            <th>연락처</th>
            <td>{sellerData?.phoneNumber || '-'}</td>
          </tr>
          <tr>
            <th>이메일</th>
            <td>{sellerData?.email || '-'}</td>
          </tr>
          <tr>
            <th>사업장 주소</th>
            <td>{sellerData?.address || '-'}</td>
          </tr>
          <tr>
            <th>사업자번호</th>
            <td>{sellerData?.businessNumber || '-'}</td>
          </tr>
        </tbody>
      </Table>
      <Footer>
        <img src={loginLogo} alt="Poen Logo" />
      </Footer>
    </Container>
  );
}

export default StuffTab4;
